// PRC-029: sesión caducada con la estética de las pantallas de estado del
// recorrido (bloque de estado de PRC-015): marca, explicación y salida clara.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SimpleLayout } from '../modules/pricingJourney/components/JourneyLayouts';
import { StatusBlock } from '../modules/pricingJourney/components/JourneyBlocks';
import { JourneyButton } from '../modules/pricingJourney/components/JourneyBasics';

const SessionExpiredPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <SimpleLayout narrow>
      <StatusBlock
        variant="warning"
        centered
        title="Tu sesión ha caducado"
        text="Por seguridad la hemos cerrado. Suele pasar tras un tiempo sin actividad o después de cambiar la suscripción. Vuelve a iniciar sesión para continuar."
        actions={<JourneyButton onClick={() => navigate('/login', { replace: true })}>Iniciar sesión</JourneyButton>}
      />
    </SimpleLayout>
  );
};

export default SessionExpiredPage;
